var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('span',{staticClass:"truck-body ma-2"},[_c('div',{staticClass:"fill text-center",style:({
        width: _vm.params.progress + '%',
        'background-color': _vm.getBackgroundColor(_vm.params.progress),
      })})]),_c('span',{staticClass:"text-caption text-secondary font-weight-bold"},[_vm._v(" "+_vm._s(_vm.params.progress)+" % ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }